/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
import { Box, ButtonBase, Grid, IconButton, useMediaQuery } from '@material-ui/core'
import { ArrowDropDown, Email, Phone, WhatsApp } from '@material-ui/icons'
import React, { useState } from 'react'
import styled from 'styled-components'
import Container from '../../components/layout_micro/container'

const Wrapper = styled.div`
  background-color: #f2f2f2;
  padding: 4em 1px 4em 0em;
`
const Title = styled.div`
  font-size: 2.2em;
  color: var(--first);
  font-family: 'imlbold'; font-weight: bold;
`
const Layout = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  @media screen and (max-width:960px) {
    display: block;
  }
`
const TitleCOntainer = styled.div`
  width: 25%;
  @media screen and (max-width:960px) {
    width: 100%;
  }
`
const Body = styled.div`
  width: 75%;
  @media screen and (max-width:960px) {
    width: 100%;
  }
`
const Card = styled.div`
  background-color: #fff;
  padding: 2em;
  border-radius: 5px;
  @media screen and (max-width:960px) {
    background-color: initial;
    padding: 0em;
    font-size: 1.1em;
  }
`
const Paragraph = styled.div`
  margin-bottom: 1.3em;
  font-family: 'imlregular';
  color: var(--first);
  font-size: 1.3em;
  span {
    font-family: 'imlbold'; font-weight: bold;
  }
`

const Text = styled.div`
  font-family: 'imlregular';
  color: var(--first);
  font-size: 1.1em;
  margin-bottom: .5em;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex;
  margin: 2em 0em 2em 0em;
  @media screen and (max-width:960px) {
    margin: 2em 0em 2em 0em;
  }
`

const Button = styled(ButtonBase)`
  padding: .4em 3em;
  border-radius: 50px;
  color: #fff;
  background-color: var(--second);
  font-size: 1.1em;
  @media screen and (max-width:960px) {
    margin: 2em 0em 2em 0em;
    padding: .9em 2em;
    border-radius: 10px;
  }
`

const TitleDragable = styled.div`
  margin-top: --1px;
  border-top: 1px solid var(--second);
  border-bottom: 1px solid var(--second);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 0em;
  svg {
    font-size: 30px;
    color: var(--second);
  }
`

const BoxAtachment = styled.div`
  margin-bottom: 2.5em;
  a {
    color: var(--first);
    text-decoration: none;
    display: block;
    font-size: 1.1em;
    :hover {
      font-weight: bold;
    }
  }
`

const AtachmentTitle = styled.div`
  color: var(--first);
  font-weight: bold;
  font-size: 1.3em;
  margin-bottom: .5em;
`
const Href = styled.a`
  color: var(--first);
  text-decoration: none;
`
const IconContact = styled(IconButton)`
  background: var(--second);
  padding: 8px;
  margin-right: 10px;
  svg {
    color: #fff;
    font-size: 20px;
  }
  :hover {
    background: var(--first);
  }
  @media screen and (max-width:600px) {
    padding: 5px;
    svg {
      font-size: 15px;
    }
  }
`
const ContactItem = styled(Grid)`
  font-size: 1.2em;
  cursor: pointer;
  font-family: 'imlbold'; font-weight: bold;
  margin-top: 1em;
`
const Info = () => {
  const isMobile = useMediaQuery('(max-width:960px)')
  const [companyActive, setCompanyActive] = useState(false)
  const [labActive, setLabActive] = useState(false)

  const DragableLab = (
    <TitleDragable onClick={() => setLabActive(true)}>
      <TitleCOntainer>
        <Title>Laboratorios Asociados</Title>
      </TitleCOntainer>
      <ArrowDropDown />
    </TitleDragable>
  )

  const dragableCOmpany = (
    <TitleDragable onClick={() => setCompanyActive(true)}>
      <TitleCOntainer>
        <Title>Empresas</Title>
      </TitleCOntainer>
      <ArrowDropDown />
    </TitleDragable>
  )

  return (
    <>
      {!companyActive && !labActive && isMobile && (
        <>
          <div id='labs' />
          <div id='company' />
          <Wrapper>
            <Container>
              {dragableCOmpany}
              {DragableLab}
            </Container>
          </Wrapper>
        </>
      )}
      {(companyActive || !isMobile) && (
        <Wrapper>
          <Container id='company'>
            <Layout>

              <TitleCOntainer>
                <Title>Empresas</Title>
              </TitleCOntainer>
              <Body>
                <Card>
                  <Paragraph>
                    Estimado Socio Comercial:
                  </Paragraph>
                  <Paragraph>
                    En <span>iml Laboratorio Médico</span> siempre preocupados por el bienestar de sus colaboradores, ofrecemos prueba RT-PCR COVID-19 con entrega de resultados
                    el mismo día (*).
                  </Paragraph>
                  <Paragraph>
                    Trabajamos bajo todos los lineamientos indicados por el <span>Instituto Nacional de Referencia Epidemiológica (InDRE)</span> y autoridades sanitarias pertinentes.
                  </Paragraph>
                  <Paragraph>
                    Ponemos a su disposición una guía de toma de muestra y embalaje de
                    acuerdo a los protocolos establecidos por la Organización Mundial de la
                    Salud. Agradecemos su confianza hacia nuestro servicio y será un honor
                    seguir contando con su amable preferencia.
                  </Paragraph>
                  <Paragraph>
                    <span>Entrega de resultados el mismo día después de 7:00 pm.</span>
                  </Paragraph>
                  <Box style={{ margin: '3em 0em' }}>
                    <Grid container spacing={2}>
                      <ContactItem xs={6} xl={4}>
                        <Href href='tel:4422130809' target='_blank'>
                          <IconContact size='small'>
                            <Phone />
                          </IconContact>
                          Tel. 442 213 0898
                        </Href>
                      </ContactItem>
                      <ContactItem xs={6} xl={3}>
                        <Href href='https://api.whatsapp.com/send?phone=5214426137391' target='_blank'>
                          <IconContact size='small'>
                            <WhatsApp />
                          </IconContact>
                          WhatsApp
                        </Href>
                      </ContactItem>
                      <ContactItem xs={12} xl={5} style={{ marginTop: isMobile ? '20px' : '' }}>
                        <Href href='mailto:empresas@laboratoriosiml.com'>
                          <IconContact size='small'>
                            <Email />
                          </IconContact>
                          empresas@laboratoriosiml.com
                        </Href>
                      </ContactItem>
                    </Grid>
                  </Box>
                  <BoxAtachment>
                    <AtachmentTitle>FORMATOS DE DESCARGA</AtachmentTitle>
                    <a target='_blank' href='https://firebasestorage.googleapis.com/v0/b/newproject-6cda3.appspot.com/o/IML_Comunicado%20Indre.pdf?alt=media&token=9cd5d2ba-5cd0-42c5-86c9-6a23fefa2e57'>Comunicado InDRE</a>
                    <a target='_blank' href='https://firebasestorage.googleapis.com/v0/b/newproject-6cda3.appspot.com/o/IML_Guia%20rapida%20toma%20de%20%20muestra%20RT-PCR%20SARS-CoV-2%20.pdf?alt=media&token=4b630439-9b5b-4aa9-80a4-9f046e940c65'>Guía rápida de toma de muestra</a>
                    <a style={{ fontSize: '1.4em' }} target='_blank' href='https://www.laboratoriosiml.com/registro/'>Formulario Epidemiológico</a>
                    <a target='_blank' href='https://firebasestorage.googleapis.com/v0/b/newproject-6cda3.appspot.com/o/IML_Consentimiento%20Informado.pdf?alt=media&token=095aa7c5-6338-4aa6-bab9-2a10eae2ad53'>Consentimiento informado</a>
                    {/* <a target='_blank' href='https://firebasestorage.googleapis.com/v0/b/newproject-6cda3.appspot.com/o/IML_Protocolo%20de%20Recepcion%20y%20Envio.pdf?alt=media&token=c431018b-8ccb-4745-a9e4-06671e7dafec'>Protocolo de recepción y envío</a> */}
                  </BoxAtachment>
                  <Text> (*) Toma de muestra de 7:15 am a 11:15 am de lunes a sábado (Ciudad de Querétaro). </Text>
                </Card>
              </Body>

            </Layout>
          </Container>
        </Wrapper>
      )}
      {companyActive && !labActive && isMobile && (
        <>
          <div id='labs' />
          <Wrapper>
            <Container>
              {DragableLab}
            </Container>
          </Wrapper>
        </>
      )}
      {!companyActive && labActive && isMobile && (
        <>
          <div id='company' />
          <Wrapper>
            <Container>
              {dragableCOmpany}
            </Container>
          </Wrapper>
        </>
      )}
      {(labActive || !isMobile) && (
        <Wrapper>
          <Container id='labs'>
            <Layout>
              <TitleCOntainer>
                <Title>Laboratorios Asociados</Title>
              </TitleCOntainer>
              <Body>
                <Card>
                  <Paragraph>
                    Estimado Laboratorio Socio:
                  </Paragraph>
                  <Paragraph>
                    En <span>iml Laboratorio Médico</span> siempre preocupados por el bienestar de sus pacientes, ofrecemos prueba RT-PCR COVID-19 con entrega de resultados el mismo día (*).
                  </Paragraph>
                  <Paragraph>
                    Trabajamos bajo todos los lineamientos indicados por el <span>Instituto Nacional de Referencia Epidemiológica (InDRE)</span> y autoridades sanitarias pertinentes.
                  </Paragraph>
                  <Paragraph>
                    Ponemos a su disposición una guía de toma de muestra y embalaje de
                    acuerdo a los protocolos establecidos por la Organización Mundial de la
                    Salud. Agradecemos su confianza hacia nuestro servicio de referencia y será
                    un honor seguir contando con su amable preferencia.
                  </Paragraph>
                  <Paragraph>
                    <span>Entrega de resultados el mismo día después de 7:00 pm.</span>
                  </Paragraph>
                  <Box style={{ margin: '3em 0em' }}>
                    <Grid container spacing={2}>
                      <ContactItem xs={6} xl={4}>
                        <Href href='tel:4422130809' target='_blank'>
                          <IconContact size='small'>
                            <Phone />
                          </IconContact>
                          Tel. 442 213 0898
                        </Href>
                      </ContactItem>
                      <ContactItem xs={6} xl={3}>
                        <Href href='https://api.whatsapp.com/send?phone=5214426137391' target='_blank'>
                          <IconContact size='small'>
                            <WhatsApp />
                          </IconContact>
                          WhatsApp
                        </Href>
                      </ContactItem>
                      {/* <ContactItem xs={12} xl={5} style={{ marginTop: isMobile ? '20px' : '' }}>
                        <Href href='mailto:empresas@laboratoriosiml.com'>
                          <IconContact size='small'>
                            <Email />
                          </IconContact>
                          empresas@laboratoriosiml.com
                        </Href>
                      </ContactItem> */}
                    </Grid>
                  </Box>
                  <BoxAtachment>
                    <AtachmentTitle>FORMATOS DE DESCARGA</AtachmentTitle>
                    <a target='_blank' href='https://firebasestorage.googleapis.com/v0/b/newproject-6cda3.appspot.com/o/IML_Comunicado%20Indre.pdf?alt=media&token=9cd5d2ba-5cd0-42c5-86c9-6a23fefa2e57'>Comunicado InDRE</a>
                    <a target='_blank' href='https://firebasestorage.googleapis.com/v0/b/newproject-6cda3.appspot.com/o/IML_Guia%20rapida%20toma%20de%20%20muestra%20RT-PCR%20SARS-CoV-2%20.pdf?alt=media&token=4b630439-9b5b-4aa9-80a4-9f046e940c65'>Guía rápida de toma de muestra</a>
                    {/* <a target='_blank' href='https://www.laboratoriosiml.com/registro/'>Formulario Epidemiológico</a> */}
                    {/* <a target='_blank' href='https://firebasestorage.googleapis.com/v0/b/newproject-6cda3.appspot.com/o/IML_Consentimiento%20Informado.pdf?alt=media&token=095aa7c5-6338-4aa6-bab9-2a10eae2ad53'>Consentimiento informado</a> */}
                    <a target='_blank' href='https://firebasestorage.googleapis.com/v0/b/newproject-6cda3.appspot.com/o/IML_Protocolo%20de%20Recepcion%20y%20Envio.pdf?alt=media&token=c431018b-8ccb-4745-a9e4-06671e7dafec'>Protocolo de recepción y envío</a>
                  </BoxAtachment>
                  <Text>
                    - (*) Recepción de muestras en Unidad Los Arcos de 7:15 am a 11:15 am de lunes
                    a sábado (Ciudad de Querétaro).
                  </Text>
                  <Text>
                    - De solicitar el servicio de recolección de muestra, la entrega de su resultado será
                    al día siguiente.
                  </Text>
                </Card>
              </Body>

            </Layout>
          </Container>
        </Wrapper>
      )}
    </>
  )
}

export default Info
